import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.Sections;

export const statusSelector = createSelector(rootSelector, (sections) => sections.status);

export const errorSelector = createSelector(rootSelector, (sections) => sections.error);

const sectionsSelector = createSelector(rootSelector, (sections) => sections.data);

export default {
  statusSelector,
  errorSelector,
  sectionsSelector,
};
